import { defineComponent as _defineComponent } from 'vue'
import { last } from 'lodash'
import { JPEG, JPG, PNG } from '@/utils/constants'
import { parseDataUrlMimeType } from '@/utils/data-url'
import { computed } from 'vue'
import MIMEType from 'whatwg-mimetype'
import VsText from '@/components/vision/VsText.vue'
import { useActions } from 'vuex-composition-helpers'

interface Props {
  value: string
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SubmissionAttachmentField',
  props: {
    value: null
  },
  setup(__props: any) {

const props = __props as {
  value: string
}



const { fetchFormSubmission } = useActions('formSubmissions', [
  'fetchFormSubmission',
])

const dataUrlProps = computed<null | MIMEType>(() => {
  return parseDataUrlMimeType(props.value)
})

const isImageAttachment = computed<boolean>(() => {
  return (
    dataUrlProps.value?.type === 'image' ||
    [PNG.extension, JPEG.extension, JPG.extension].some(
      (ext) => urlFileExtension.value?.toLowerCase() === ext
    )
  )
})

const urlFileExtension = computed<string | undefined>(() => {
  return new URL(props.value).pathname.split('.').pop()
})

const fileName = computed<string>(() => {
  if (dataUrlProps.value) {
    return decodeURIComponent(
      dataUrlProps.value.parameters.get('download') ?? 'unknown'
    )
  }

  const rawFileName = last(new URL(props.value).pathname.split('/'))
  return decodeURIComponent(rawFileName ?? '')
})

function attachmentClicked() {
  if (dataUrlProps.value) {
    // Old style, stored in DB as data:url
    const image = new Image()
    image.src = props.value

    const newWindow = window.open('', '_blank')
    newWindow?.document.write(image.outerHTML)
  } else {
    if (isTokenValid()) {
      window.open(props.value, '_blank')
      return
    }

    const submissionId = getSubmissionId()
    if (submissionId == null) {
      return
    }
    fetchFormSubmission(submissionId)
  }
}

function getSubmissionId(): string | null {
  const urlSegments = props.value.split('/')
  const submissionIndex = urlSegments.length - 2
  if (submissionIndex < 0) {
    return null
  }

  return urlSegments[submissionIndex]
}

function isTokenValid() {
  const urlParams = new URLSearchParams(props.value)
  const expiry = urlParams.get('se')

  if (expiry) {
    const date = Date.parse(expiry)
    const now = Date.parse(new Date().toISOString())
    return date > now
  }

  // Could not get the expiry from the url. Assume still valid to prevent any infinite loops
  return true
}

return { __sfc: true,props, fetchFormSubmission, dataUrlProps, isImageAttachment, urlFileExtension, fileName, attachmentClicked, getSubmissionId, isTokenValid, VsText }
}

})